import React from 'react';
import './Styles/Testimonial.scss';
import Carousel from 'react-elastic-carousel';
import {FaLongArrowAltRight,FaLongArrowAltLeft} from 'react-icons/fa';
import ButtonBase from "@material-ui/core/ButtonBase";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { slides } from './data';
const breakPoints = [
    { width: 1, itemsToShow: 1 }
];

class Testimonial extends React.Component {
    renderArrows = () => {
        return (
          <div className="slider-arrow">
            <ButtonBase
              className="arrow-btn prev"
              onClick={() => this.slider.slickPrev()}
            >
              <FaLongArrowAltLeft className="icon "/>
            </ButtonBase>
            <ButtonBase
              className="arrow-btn next"
              onClick={() => this.slider.slickNext()}
            >
              <FaLongArrowAltRight className="icon"/>
            </ButtonBase>
          </div>
        );
      };
      render(){
          return(
              <div className="testimonial-customer-story">
               <Slider  className="slider" ref={(c) => (this.slider = c)} dots={false}
            arrows={false}
            slidesToShow={1}
            speed={300}
            >
                  {slides.map((item) =>{
                      return(
                          <div>
                              <div className="image">

                              <img  src={item.profile} />
                              </div>
                              <p>{item.feedback}</p>
                              <h4>{item.name} <span>- Read Case Study</span></h4>
                          </div>
                      )
                  })}

               </Slider>
                {this.renderArrows()}
              </div>
          )
      }
};
export default Testimonial ;